import React from 'react';

const RedlineLogo = ({ width = 200, height = 40, className = "", dark = false }) => {
  const primary = dark ? "text-[#1A1A1A]" : "text-white";
  const secondary = dark ? "text-[#1A1A1A]/55" : "text-white/65";
  return (
    <div className={`flex items-center space-x-3 ${className}`} style={{ width, height }}>
      <svg width="30" height="30" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M 50 0 A 50 50 0 0 1 100 50 L 50 50 Z" fill="#D32F2F" />
        <path d="M 0 100 L 50 50 L 0 50 Z" fill="#D32F2F" />
        <path d="M 50 50 L 100 100 L 50 100 Z" fill="#D32F2F" />
      </svg>
      <div className="flex flex-col leading-none">
        <span className={`${primary} font-head text-base font-extrabold tracking-tight`}>
          Redline<sup className="text-[9px]">™</sup> Monitoring
        </span>
        <span className={`${secondary} text-[9px] font-semibold uppercase tracking-[0.22em] mt-1`}>
          Services Inc.
        </span>
      </div>
    </div>
  );
};

export default RedlineLogo;
